import * as React from 'react';
import { Dispatch } from 'redux';

import { ICartModel } from '../../cart/reducers/cart-reducer';
import { removeAllSeatsFromCart } from '../../cart/actions/cart-actions';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { IApplicationModel } from '../../reducers/app-reducer';


interface ICartTimerProps {
    cartTimerExpiringMinute: number;
    cartTimerMessaging: string;
    remainingCartTimer: number;
    cartUrl: string;
}

class CartTimer extends React.Component<ICartTimerProps, { seconds: any, minutes: any, expiring: boolean }>{
    private secondsRemaining: number;
    private intervalHandle: NodeJS.Timer;
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.tick = this.tick.bind(this);

        if (props.remainingCartTimer > 0) {
            var secs = Math.floor((+(props.remainingCartTimer % 1).toFixed(4)) * 60);
            this.state = {
                ...this.state,
                minutes: Math.floor(props.remainingCartTimer),
                seconds: secs,
                expiring: false
            };
            this.startCountDown();
        } else {
            this.state = {
                seconds: '0',
                minutes: '',
                expiring: false
            }
        }
        this.secondsRemaining;
        this.intervalHandle;

    }

    handleChange(event) {
        this.setState({
            minutes: event.target.value
        })
    }

    tick() {
        var min = Math.floor(this.secondsRemaining / 60);
        var sec = this.secondsRemaining - (min * 60);

        var newSeconds = sec.toString();
        var newMinutes = min.toString();
        var expiring = false;

        if (sec < 10 && newSeconds.length < 2) {
            newSeconds = "0" + newSeconds;
        }
        if (min < 10 && newMinutes.length < 2) {
            newMinutes = "0" + newMinutes;
        }
        if (min < this.props.cartTimerExpiringMinute) {
            expiring = true;
        }

        if (min === 0 && sec === 0) {
            clearInterval(this.intervalHandle);
        }
        this.setState({
            minutes: newMinutes,
            seconds: newSeconds,
            expiring: expiring
        });
        this.secondsRemaining--
    }

    startCountDown() {
        var appContainer = document.getElementById('app-container');
        appContainer.classList.add('cart-timer-active');

        this.intervalHandle = setInterval(this.tick, 1000);
        let time = this.state.minutes;
        this.secondsRemaining = (time * 60) + this.state.seconds;
    }

    componentWillReceiveProps(nextProps: ICartTimerProps) {
        if (this.props.remainingCartTimer !== nextProps.remainingCartTimer
            && this.state.minutes.length === 0) {
            this.setState({
                ...this.state,
                minutes: nextProps.remainingCartTimer
            });
            this.startCountDown();
        }
    }

    currentTimerMsg() {
        return { __html: this.props.cartTimerMessaging.replace('{1}', "<span>" + this.state.minutes + ":" + this.state.seconds + "</span>")};
    }

    render() {
        return (
            <div className={'cart-timer' + (this.state.expiring ? ' cart-timer-expiring' : '')}>
                <div className="cart-timer-inner">
                    <p className="caption-paragraph" dangerouslySetInnerHTML={this.currentTimerMsg()} />
                </div>
            </div>
        );
    }

}

export default CartTimer;
